import { render } from "./newcards.vue?vue&type=template&id=caa7ecec&scoped=true"
import script from "./newcards.vue?vue&type=script&lang=js"
export * from "./newcards.vue?vue&type=script&lang=js"

import "./newcards.vue?vue&type=style&index=0&id=caa7ecec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa7ecec"]])

export default __exports__